import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { ProductReveal } from './components/ProductReveal';
import { Offer } from './components/Offer';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { StickyCtaBar } from './components/StickyCtaBar';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  return <div className="min-h-screen w-full bg-carbon-950 font-sans text-slate-200" data-id="element-0" data-mp="2mm2n0i3g2z50">
      <main data-id="element-1" data-mp="31aqeac69cmp5">
        <Hero data-id="element-2" data-mp="31agoopp4khjz" />
        <PainPoints data-id="element-3" data-mp="31ayr642drs0c" />
        <ProductReveal data-id="element-4" data-mp="31bi9vmzuukff" />
        <Offer data-id="element-5" data-mp="31cte1nx7pu72" />
        <Testimonials data-id="element-6" data-mp="31cjk5p91r2w3" />
        <Faq data-id="element-7" data-mp="2wjgp1comflds" />
        <FinalCta data-id="element-8" data-mp="2wiyxuugtfxcq" />
      </main>
      <SiteFooter data-id="element-9" data-mp="2wip54z4dzc3c" />
      <StickyCtaBar data-id="element-10" data-mp="2wi5lndz38fn7" />
    </div>;
}